import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const MobileService = ({ handleCloseMobileNav }) => {
  const navigate = useNavigate();
  const handleClick = (path) => {
    navigate(path);
    handleCloseMobileNav();
  };
  const linkClass =
    "flex justify-between   px-4 items-center py-2 rounded font-medium text-gray-800 no-underline hover:bg-blue-100 hover:text-main transition-colors duration-300";

  const Services = [
    { name: "Web Solution", path: "/web-solution" },
    {
      name: "Content Management System",
      path: "/content-management-system",
    },
    { name: "E-Commerce", path: "/e-commerce-services" },
    {
      name: "CRM SCM and ERP Services",
      path: "/cRM-sCM-and-eRP-services",
    },
    { name: "Mobile Application", path: "/mobile-application-services" },
    {
      name: "SEO Services",
      path: "/seo-services",
    },
    {
      name: "Application Migration",
      path: "/application-migration",
    },
    {
      name: "Technical Maintenance",
      path: "technical-maintenance-services",
    },
    {
      name: "EAI service",
      path: "/eAI-services",
    },
  ];

  return (
    <div className="w-full  bg-white rounded  text-sm text-gray-800 overflow-y-auto max-h-[80vh]">
      <p className="text-[15px]">
        {Services.map((item) => (
          <span key={item.path}>
            <button
              onClick={() => handleClick(item.path)}
              className={`${linkClass} w-full text-left`}
            >
              <span className=" pl">{item.name}</span>
              <FontAwesomeIcon icon={faChevronRight} className=" text-[11px]" />
            </button>
          </span>
        ))}
      </p>
    </div>
  );
};

export default MobileService;
